import { defaultColumns, defaultSort } from '../../components/data/products/categories/columns';

export default {
  state: {
    productCategories: [],
    tableConfig: null,
    loading: false,
  },
  getters: {
    productCategories: state => state.productCategories,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
  },
  mutations: {
    setProductCategories(state, productCategories) {
      state.productCategories = productCategories;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      commit('setLoading', true);
      try {
        const setting = await axios.get('api/table-settings/product-category-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'product-category-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'product-category-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchAll({ commit }, queryString) {
      commit('setLoading', true);
      try {
        const setting = await axios.get('api/table-settings/product-category-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'product-category-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'product-category-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
        const productCategories = await axios.get('api/product-categories' + (queryString || ''));
        commit('setProductCategories', productCategories);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/product-categories/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/product-categories', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/product-categories', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/product-categories/${id}`);
    },
  },
};
